import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/profile/Workspace.tsx");
